module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921045651_T.87146bdd.jpg";